<div class="floatLabel registro" [ngClass]="{'soloLectura' : disabled}">

  <div class="dropdown select" [ngClass]="{'is-filled' : datoSeleccionado.length, 'margenControl' : margenControl }" dropdown >

    <ul class="dropdown-menu multiselectCustom" aria-labelledby="multiSelect" style="width: 100%"  id="multiSelect{{id}}" #ddMenu>

      <li>
        <dx-sortable
        filter=".dx-treeview-item"
        [allowDropInsideItem]="false"
        [allowReordering]="false"
        >
        <dx-tree-view
          id="treeview"
          [dataSource]="opciones"
          dataStructure="tree"
          [showCheckBoxesMode]="'selectAll'"
          (onSelectionChanged)="treeViewSelectionChanged($event)"
          [searchEnabled]="true"
          searchMode="contains"
          itemTemplate="itemTemplate"
          >
          <dxo-search-editor-options placeholder="Buscar"> </dxo-search-editor-options>
          <div *dxTemplate="let itemObj of 'itemTemplate'">
                <div>{{itemObj.text}}</div>
          </div>
        </dx-tree-view>
      </dx-sortable>
      </li>
    </ul> 

    <div class="btnDropdown ddSelect {{clasesAdicionales}}" [ngClass]="{'disabled' : disabled}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="FocusBuscar()">

      
      <!-- opciones seleccionadas -->
      <div class="texto" >
        {{cadenaSeleccionados}}
    </div>

    <!-- Limpiar control -->
     <div class="btnTimes dropdownTimes" *ngIf="limpiarInput && !disabled  && datoSeleccionado.length > 0" (click)="LimpiarSelect()">

      <span class="fa fa-times"></span>
    </div>

    <!-- icono dd -->
    <div class="abrir">
      <span class="fa fa-caret-down"></span>
    </div>

  </div>
      <!-- Mensaje error -->
      <span *ngIf="verError" class="textoError" [hidden]="datoSeleccionado && datoSeleccionado.length != 0 || !errorActivo">
        {{mensajeError}}
      </span>

  </div>

  <!-- Label (título del control) -->
  <label>{{titulo}}</label>

</div>
